var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmptyJobIcon = function SvgEmptyJobIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 118,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92 117.5c50.81 0 92-8.943 92-19.976 0-11.032-41.19-19.975-92-19.975S0 86.492 0 97.524C0 108.557 41.19 117.5 92 117.5Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.125 39.766-29.17-32.823c-1.4-2.237-3.444-3.59-5.597-3.59H60.642c-2.153 0-4.197 1.353-5.597 3.588l-29.17 32.828v26.365h132.25V39.766Z",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.637 48.815c0-4.58 2.858-8.361 6.403-8.364h32.085v51.757c0 6.058-3.795 11.024-8.481 11.024H34.356c-4.686 0-8.481-4.969-8.481-11.024V40.451H57.96c3.545 0 6.403 3.776 6.403 8.356v.063c0 4.58 2.889 8.278 6.431 8.278h42.412c3.542 0 6.431-3.733 6.431-8.313v-.02Z",
    fill: "#FAFAFA",
    stroke: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h184v117H0z"
  })))));
};
export default SvgEmptyJobIcon;